import { Select } from '@iqueue/ui-kit'
import { useCallback, useRef } from 'react'
import RolePresenter from '../../api/rolePresenter'
import useTranslate from '../../hooks/useTranslate'

export default function PickRole({
  name = 'nodeId',
  current,
  value,
  onChange,
  ...props
}) {

  const cache = useRef()
  const { t } = useTranslate()

  const render = useCallback((id) => {
    const item = cache.current.indexed[id]

    return {
      id: id,
      title: item?.name,
    }
  }, [t, current])

  const fetchData = useCallback(() => {
    return RolePresenter.readIndexed(cache)
  }, [])

  const handleChange = useCallback((selectedId) => {
    const selectedRole = cache.current.indexed[selectedId]
    onChange(selectedId, selectedRole)
  }, [])

  return <Select
    name={ name }
    entries={ fetchData }
    render={ render }
    onChange={ handleChange }
    value={ value }
    { ...props }
  />
}
